import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { TextArea } from '@/components/ui/textarea';
import { cn } from '@/lib/cn';
import type { BaseInstance } from '@pigello/pigello-matrix';
import type { Path } from 'react-hook-form';
import type { FieldProps } from '../types';

type TextAreaFieldProps = {
  resize?: boolean;
  rows?: number;
  cols?: number;
  overrideRequired?: boolean;
  onValueChange?: (value: unknown) => void;
};

export function Textarea<Instance extends BaseInstance = BaseInstance>({
  formField,
  name,
  placeholder,
  label,
  description,
  horizontal,
  className,
  resize,
  rows = 4,
  cols = 50,
  disabled,
  canHandleField,
  overrideRequired,
  onValueChange,
}: FieldProps<Instance> & TextAreaFieldProps) {
  if (horizontal) {
    return (
      <FormField
        rules={{
          required:
            (overrideRequired || formField.required) &&
            'Detta fält är obligatoriskt',
        }}
        control={formField.control}
        name={name as Path<Instance>}
        render={({ field }) => (
          <FormItem
            className={cn('flex items-center justify-between', className)}
          >
            <div className='w-1/2 shrink-0'>
              <FormLabel>
                {label ?? formField.label}{' '}
                {(overrideRequired || formField.required) && <span>*</span>}
              </FormLabel>
              <FormDescription>
                {description ?? formField?.description}
              </FormDescription>
              <FormMessage />
            </div>
            <FormControl>
              <TextArea
                {...field}
                required={overrideRequired || formField.required}
                value={field.value ?? ''}
                onChange={(e) => {
                  field.onChange(e);
                  onValueChange?.(e);
                }}
                className={
                  resize
                    ? ''
                    : 'resize-none placeholder:text-muted-foreground/70'
                }
                placeholder={placeholder ?? formField.label}
                rows={rows}
                cols={cols}
                disabled={disabled ?? field.disabled ?? !canHandleField}
              />
            </FormControl>
          </FormItem>
        )}
      />
    );
  }
  return (
    <FormField
      rules={{
        required:
          (overrideRequired || formField.required) &&
          'Detta fält är obligatoriskt',
      }}
      control={formField.control}
      name={name as Path<Instance>}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel>
            {label ?? formField.label}{' '}
            {(overrideRequired || formField.required) && <span>*</span>}
          </FormLabel>
          <FormControl>
            <TextArea
              {...field}
              value={field.value ?? ''}
              onChange={(e) => {
                field.onChange(e);
                onValueChange?.(e);
              }}
              required={overrideRequired || formField.required}
              className={
                resize ? '' : 'resize-none placeholder:text-muted-foreground/70'
              }
              placeholder={placeholder ?? formField.label}
              rows={rows}
              cols={cols}
              disabled={disabled ?? field.disabled ?? !canHandleField}
            />
          </FormControl>
          <FormDescription>
            {description ?? formField?.description}
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
